// extracted by mini-css-extract-plugin
module.exports = {"Loader":"spinner_Loader__1F8Wv","load6":"spinner_load6__F9t02","round":"spinner_round__2Hs3O"};